module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/desktop/dashkit-alt-mixed-cropped-5a729c4305eedf0fdb768fb05a2b2980.png";